import React, { useEffect, useMemo } from 'react';
import { AgentProfileMetrics } from '@accuhealth/call-dashboard-ui';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Routes } from 'router/routes';
import { isValidGuid } from 'infrastructure/functions';
import { showResult } from 'infrastructure/hooks/utils';
import { useTranslation } from 'react-i18next';

const CallAgentProfileDashboardPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { agentGuid: _agentGuid } = useParams<{ agentGuid: string }>();
  const agentGuid = _agentGuid!;

  const goBackPath = useMemo(() => {
    return location.state?.from || Routes.callAgentsDashboardMetrics;
  }, []);

  useEffect(() => {
    if (!agentGuid || !isValidGuid(agentGuid)) {
      showResult(t('errors.invalidGuid'));
      navigate(Routes.notFound, { replace: true });
    }
  }, [_agentGuid, navigate]);

  return (
    <div>
      <AgentProfileMetrics agentId={agentGuid} goBackPath={goBackPath} />
    </div>
  );
};

export default CallAgentProfileDashboardPage;
